import invariant from 'invariant';

import { getIn } from 'utils/functional';

let config: Record<string, unknown>;

export function configValue(...path: string[]): string | null | undefined {
  return getIn(config, path);
}

export function requiredConfig(...path: Array<string>): unknown {
  const value = getIn(config, path);
  invariant(value, `Config value ${path.toString()} is required`);

  return value;
}

export function configString(...path: string[]): string {
  const value = requiredConfig(...path);
  return typeof value === 'string' ? value : '';
}

export function setConfigOnce(newConfig: Record<string, unknown>) {
  if (!config) {
    config = newConfig;
  }
}
